import "rapidoc";

const ApiDocs = () => {
  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <rapi-doc
        spec-url="https://wrd-ngdi-api-wrd-test.eu.mike-cloud-test.com/openapi/v1.json"
        render-style="read"
        layout="row"
        allow-try="true"
        allow-authentication="false"
        allow-server-selection="true"
        schema-style="table"
        response-area-height="300px"
        show-header="true"
      />
    </div>
  );
};

export default ApiDocs;
